export default {
  getStudentInfo (state, payload) {
    var dropTimeCopy = ['','','','','','']
    if (payload.studentInfo.drop_time != null) {
      dropTimeCopy = payload.studentInfo.drop_time.split(',')
    }
    payload.studentInfo.drop_time = dropTimeCopy
    state.studentInfo = payload.studentInfo
    if (state.studentInfo.class_info == null) {
      state.studentInfo.class_info = {
        id: "", name: "", grade: null
      }
    }

    if (state.studentInfo.place_info == null) {
      state.studentInfo.place_info = {
        id: "", name: ""
      }
    }

    if (state.studentInfo.parent_info == null) {
      state.studentInfo.parent_info = {
        id: "", name: ""
      }
    }
  },

  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
